module.exports = __webpack_public_path__ + "img/blue.21d8e983.png";